import React from "react";
import {
  Image,
  Row,
  Col,
  Container,
  Button
} from 'react-bootstrap';
import Translate from "../../../../../../../translate";
import "./PagoServicio.css";
import Planeta from "../../../../../img/BannerServicios_NubePlaneta.png";
import CriptoPhone from "../../../../../img/BannerServicios_CelularCripto.png";
import IzziLogo from "../../../../../img/Logo_izzi.png";
import CfeLogo from "../../../../../img/Logo_cfe.png";
import TelcelLogo from "../../../../../img/Logo_telcel.png";
import TotalplayLogo from "../../../../../img/Logo_totalplay.png";
import NaturgyLogo from "../../../../../img/Logo_naturgy.png";
import ManoCrypto from "../../../../../img/banner-servicios-mobile.png";

const PagoServicios = ({lan}) => {

  const logos = [
    IzziLogo,
    TelcelLogo,
    CfeLogo,
    NaturgyLogo,
    TotalplayLogo,
  ]

  const getColumnMobile = (logo) => {
    switch (logo){
      case IzziLogo:
        return <Col xs={4} className="text-right"><Image width={65} src={IzziLogo} /></Col>;
      case TelcelLogo:
        return <Col xs={4} className="text-center"><Image width={65} src={TelcelLogo} /></Col>;
      case CfeLogo:
        return <Col xs={4}><Image width={65} src={CfeLogo} /></Col>
      case NaturgyLogo:
        return <Col xs={6} className="text-right"><Image width={65} src={NaturgyLogo} /></Col>;
      case TotalplayLogo:
        return <Col xs={6}><Image width={65} src={TotalplayLogo} /></Col>
    }
  }

  return (
    <div className='comisiones-outter'>
      <div className="align-ilustration">
        <Image src={Planeta} className="cripto-planet"/>
        <Image src={CriptoPhone} className="cripto-cel"/>
        <Image src={ManoCrypto} className="mobile-img"/>
      </div>
      <Row className="align-items-center mobile-services">
        {
          logos && logos.length > 0 &&
          logos.map((logo) => getColumnMobile(logo))
        }
      </Row>
      <div className="mobile-logos">
        {
          logos && logos.length > 0 &&
          logos.map((logo) => {
            return(
              <div className="responsive-items-mobile">
                <Image className="item" src={logo} />
              </div>
            )
          })
        }
      </div>
      <Container>
        <Row>
          <Col xl={7} lg={6}>
            <p>
              <span className="services-title">{Translate[lan].landing3.banner.servicio.titulo}</span>
              <br/>
              <span className="services-subtitle">
                {Translate[lan].landing3.banner.servicio.subtitulo1}
                <br/>
                {Translate[lan].landing3.banner.servicio.subtitulo2}
              </span>
              <span className="services-subtitle-mobile">
                {Translate[lan].landing3.banner.servicio.subtitulo1} {Translate[lan].landing3.banner.servicio.subtitulo2}
              </span>
            </p> 
            <div className="align-btn-services">
              <Button 
                className='main-button'
                onClick={()=>window.open(window.location.origin + '/register','_blank')}
              >
                {Translate[lan].landing3.banner.button1}
              </Button>
            </div>
            <div className="responsive-logos">
              {
                logos && logos.length > 0 &&
                logos.map((logo) => {
                  return(
                    <div className="responsive-items">
                      <Image className={logo !== IzziLogo ? "item" : "item-izzi"} src={logo} />
                    </div>
                  )
                })
              }
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PagoServicios;